import React from 'react';

const IframeHelper = ({
  frameName,
  source,
  frameWidth,
  frameHeight,
  alignment,
  allowScrolling = 'no',
  borderWidth = '0',
  marginWidth = '0',
  marginHeight = '0',
  sandbox = false
}) => {
  return sandbox ? (
    <iframe
      name={frameName}
      src={source}
      width={frameWidth}
      height={frameHeight}
      align={alignment}
      scrolling={allowScrolling}
      frameBorder={borderWidth}
      marginWidth={marginWidth}
      marginHeight={marginHeight}
      sandbox={sandbox}
    />
  ) : (
    <iframe
      name={frameName}
      src={source}
      width={frameWidth}
      height={frameHeight}
      align={alignment}
      scrolling={allowScrolling}
      frameBorder={borderWidth}
      marginWidth={marginWidth}
      marginHeight={marginHeight}
    />
  );
};

export default IframeHelper;
